import { render, staticRenderFns } from "./createPoll.vue?vue&type=template&id=853287f0&"
import script from "./createPoll.vue?vue&type=script&lang=ts&"
export * from "./createPoll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports